<div tid="float-menu-draft-panel" class="float-menu-draft-panel-container">
    <div class="float-menu-container">
        <div class="item-draft-count" (click)="showFloatMenuWithoutDraftList()">
            Drafts ({{draftCount}})
        </div>
        <div class="item-icons-list" kendoTooltip position="top" tooltipClass="tooltip-adjust-right">
            <smart-icon class="item-icons light" name="add-note" (click)="_floatMenuService.showAddNoteDialog()"
                title="Create Note (Type &quot;n&quot;)">
            </smart-icon>
            <smart-icon class="item-icons light" name="add-contact" (click)="_floatMenuService.showAddContactDialog()"
                title="Create Contact (Type &quot;c&quot;)">
            </smart-icon>
            <smart-icon class="item-icons light" name="add-entity" (click)="_floatMenuService.showAddEntityDialog()"
                title="Create Entity (Type &quot;e&quot;)">
            </smart-icon>
            <div class="item-line">
            </div>
        </div>
    </div>
    <div class="draft-action-container">
        <div class="tool-bar">
            <div tid="keyword-search " class="search-box">
                <keyword-search [config]="keywordSearchConfig"></keyword-search>
            </div>
            <div tid="refresh" class="refresh-box">
                <smart-icon tid="refresh_icon" name="refresh" (click)="onRefreshClicked()" class="light">
                </smart-icon>
            </div>
            <div tid="draft-sort" class="item-draft-sort">
                <sort [sortInfo]="sortInfo" (change)="onSortSelect($event)" [isDraft]="true"
                    [sortChangeSubject]="sortChangeSubject">
                </sort>
            </div>
        </div>
    </div>
    <div class="no-data-box" *ngIf="draftCount===0">
        <span>No Data Found</span>
    </div>
    <div class="item-draft-list" *ngIf="draftCount>0">
        <draft-list [config]="threadListConfig"></draft-list>
    </div>
</div>